import script from "./PathPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./PathPicker.vue?vue&type=script&setup=true&lang=ts"

import "./PathPicker.vue?vue&type=style&index=0&id=5e973c3c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e973c3c"]])

export default __exports__